import {
  Component,
  OnInit,
  ElementRef,
  QueryList,
  ContentChildren,
  Input,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';
import { CarouselItemComponent } from '../carousel-item/carousel-item.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    standalone: false
})
export class CarouselComponent implements OnInit {
  @Output() panNext = new EventEmitter();
  @Output() panPrev = new EventEmitter();
  @ContentChildren(CarouselItemComponent) items: QueryList<CarouselItemComponent>;

  @Input() index = 0;
  panning = false;
  panDelta = 0;
  panDisabled = false;
  private pointer: { id: number; x: number; y: number; time: number; axis: 'x' | 'y' | null } | null = null;
  private suppressClick = false;

  constructor(private sanitization: DomSanitizer, private element: ElementRef) {}

  ngOnInit() {
    // setInterval(() => {
    //   this.next();
    // }, 1000);
  }

  next(wrap = true) {
    if (wrap) {
      this.index = (this.index + 1) % this.items.length;
    } else {
      this.index = this.index === this.items.length - 1 ? this.index : this.index + 1;
    }
  }

  prev(wrap = true) {
    if (wrap) {
      this.index = this.index === 0 ? this.items.length - 1 : this.index - 1;
    } else {
      this.index > 0 && this.index--;
    }
  }

  // Native pointer events: horizontal drags move the cards, vertical ones are left to the page scroll.
  onPointerDown(event: PointerEvent) {
    if (this.panDisabled || (event.pointerType === 'mouse' && event.button !== 0)) return;
    this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp, axis: null };
  }

  onPointerMove(event: PointerEvent) {
    const p = this.pointer;
    if (!p || p.id !== event.pointerId) return;
    const dx = event.clientX - p.x;
    const dy = event.clientY - p.y;
    if (!p.axis) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      p.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (p.axis === 'y') return;
      this.panning = true;
      (event.currentTarget as HTMLElement).setPointerCapture?.(event.pointerId);
    }
    if (p.axis !== 'x') return;
    event.preventDefault();
    this.panDelta = dx;
  }

  // Moves on a drag past a third of the width, or on a quick flick (the usual gesture on phones).
  onPointerUp(event: PointerEvent) {
    const p = this.pointer;
    if (!p || p.id !== event.pointerId) return;
    this.pointer = null;
    if (p.axis !== 'x') return;
    const width = this.element.nativeElement.getBoundingClientRect().width;
    const velocity = this.panDelta / Math.max(event.timeStamp - p.time, 1);
    const flick = Math.abs(velocity) > 0.3 && Math.abs(this.panDelta) > 20;
    if (event.type !== 'pointercancel') {
      if (-this.panDelta > width / 3 || (flick && this.panDelta < 0)) {
        this.next(false);
        this.panNext.emit();
      } else if (this.panDelta > width / 3 || (flick && this.panDelta > 0)) {
        this.prev(false);
        this.panPrev.emit();
      }
    }
    this.suppressClick = Math.abs(this.panDelta) > 8;
    this.panning = false;
    this.panDelta = 0;
  }

  // A drag that ends over a link must not open it.
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.suppressClick) return;
    this.suppressClick = false;
    event.preventDefault();
    event.stopPropagation();
  }

  get translateX() {
    return this.sanitization.bypassSecurityTrustStyle(`translateX( calc( -${this.index * 100}% + ${this.panDelta}px) )`);
  }

  get slowTransition() {
    return this.sanitization.bypassSecurityTrustStyle(`transform 1s ease`);
  }

  // Used by the onboarding overlay template (arrows and page dots).
  public currentIndex() {
    return this.index;
  }
}
